<div class="modal-header">
	<h5 class="modal-title w-100 text-center fw-semibold">
		{{ "RELATIONSHIP_HISTORY.MODAL.CONFIRM_RETURN" | translate }}
	</h5>
	<button
		(click)="cancel()"
		type="button"
		class="btn-close close pull-right"
		aria-label="Close"
	></button>
</div>

<div class="modal-body d-flex flex-column align-items-center modal-body-custom">
	<span class="m-3">
		{{ "RELATIONSHIP_HISTORY.MODAL.DESCRIPTION" | translate }}
	</span>
</div>

<div class="modal-footer">
	<button
		(click)="cancel()"
		[disabled]="loading"
		type="button"
		class="btn btn-secondary me-2"
	>
		<span class="m-1">
			{{ "RELATIONSHIP_HISTORY.MODAL.CANCEL" | translate }}
		</span>
	</button>
	<button
		(click)="confirm()"
		[disabled]="loading"
		type="button"
		class="btn btn-primary btn-primary me-0"
	>
		<ng-container *ngIf="loading">
			<span
				class="spinner-border spinner-border-sm me-2"
				role="status"
			></span>
		</ng-container>
		{{ "RELATIONSHIP_HISTORY.MODAL.CONFIRM_RETURN" | translate }}
	</button>
</div>
